import { render, staticRenderFns } from "./RatingStar.vue?vue&type=template&id=2b6529d6&scoped=true&lang=pug"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"
import style0 from "./RatingStar.vue?vue&type=style&index=0&id=2b6529d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6529d6",
  null
  
)

export default component.exports